const getNameFromEmail = (email: string) => {
    const fullName = email.substring(0, email.lastIndexOf('@'));

    const nameBeforeDot = fullName.split('.')[0];

    return nameBeforeDot.charAt(0).toUpperCase() + nameBeforeDot.slice(1);
};

export default getNameFromEmail;
